export const rootStyles = {
  position: 'absolute',
  bottom: '100%',
  left: 0,
  right: 0,
  marginBottom: 1,
  maxHeight: 240,
  overflowY: 'auto',
  boxShadow: 3,
  backgroundColor: 'background.paper',
  borderRadius: 1,
  zIndex: 10,
};

export const itemStyles = {
  display: 'flex',
  alignItems: 'center',
  gap: 1,
  padding: '8px 12px',
  cursor: 'pointer',
  '&:hover': {
    backgroundColor: 'action.hover',
  },
};

export const focusedItemStyles = {
  ...itemStyles,
  backgroundColor: 'action.selected',
};

export const commandLabelStyles = {
  minWidth: 90,
  color: theme => theme.palette.text.primary,
};

export const commandDescriptionStyles = {
  color: theme => theme.palette.text.secondary,
};
